/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outside_HeadlineInputs */

const en_outside_headline = /** @type {(inputs: Outside_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything else, through one door.`)
};

/**
* | output |
* | --- |
* | "Everything else, through one door." |
*
* @param {Outside_HeadlineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const outside_headline = /** @type {((inputs?: Outside_HeadlineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outside_HeadlineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_outside_headline(inputs)
});